import React from "react";
import styles from "../PricingWrapper.module.scss";
import { withStyles, Radio, Grid } from "@material-ui/core";
import ModelDropDown from "../currentPricing/ModelDropDown";
import YearDropDown from "../currentPricing/YearDropDown";

const StyledRadio = withStyles({
  root: {
    color: "#102b4e",
    "&$checked": {
      color: "#102b4e",
      "&$disabled": {
        color: "#bbb",
      },
    },
  },
  disabled: {},
  checked: {},
})(Radio);

export const DropDownContainer = (props) => (
  <div className={styles.modelDiv}>
    <div className={styles.dropdownContainer}>
      <Grid item md={3} xs={4}>
        <div className={styles.subTitle}>{props.t("NamePlate.model")}</div>
        <ModelDropDown
          {...props.props}
          modelData={props.modelData}
          selectedModel={props.selectedModel}
          modelDropDownValues={props.modelDropDownValues}
          updateModel={props.updateModel}
        />
      </Grid>

      <Grid item md={3} xs={4}>
        <div className={styles.subTitle}>{props.t("NamePlate.modelYear")}</div>
        <YearDropDown
          {...props.props}
          yearValues={props.yearValues}
          updateYear={props.updateYear}
          selectedYear={props.selectedYear}
          showAll={false}
        />
      </Grid>
    </div>
  </div>
);

export const TableHeader = (props) => (
  <thead>
    <tr>
      <th>{props.t("PricingWrapper.priceEvent")}</th>
      <th>
        <p>
          {props.t("PricingWrapper.nscPendingAction")}:{" "}
          {props.t("GeneralEMP.statusYes")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerPendingAction")}:{" "}
          {props.t("GeneralEMP.statusYes")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerEligibility")}:{" "}
          {props.t("PricingWrapper.offline")}
        </p>
      </th>
      <th>
        <p>
          {props.t("PricingWrapper.nscPendingAction")}:{" "}
          {props.t("PricingWrapper.noActionStatus")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerPendingAction")}:{" "}
          {props.t("GeneralEMP.statusYes")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerEligibility")}:{" "}
          {props.t("PricingWrapper.offline")}
        </p>
      </th>
      <th>
        <p>
          {props.t("PricingWrapper.nscPendingAction")}:{" "}
          {props.t("PricingWrapper.noActionStatus")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerPendingAction")}:{" "}
          {props.t("PricingWrapper.noActionStatus")}
        </p>
        <p>
          {props.t("PricingWrapper.dealerEligibility")}:{" "}
          {props.t("PricingWrapper.eligibilityNotImpacted")}
        </p>
      </th>
    </tr>
  </thead>
);

export const TableCell = ({
  onChange,
  isEmpty,
  checked,
  disabled,
  groupName,
}) => {
  return (
    <td>
      <Grid container justify="center" alignItems="center">
        {!(isEmpty && !checked) && (
          <StyledRadio
            type="radio"
            name={`${groupName}`}
            onChange={onChange}
            checked={checked}
            disabled={disabled}
          />
        )}
      </Grid>
    </td>
  );
};
